import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSearchBoxComponent } from './search-box.component';
import { RouterModule } from '@angular/router';
import { IconModule, MediaModule, NgSelectA11yModule, OutletModule } from '@spartacus/storefront';
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, provideConfig } from '@spartacus/core';
import { HighlightPipe } from './highlight.pipe';
import { TooltipIconComponent } from "../../../../../components/tooltip-icon/tooltip-icon.component";

@NgModule({
  declarations: [CustomSearchBoxComponent, HighlightPipe],
  imports: [
    CommonModule,
    RouterModule,
    MediaModule,
    IconModule,
    UrlModule,
    I18nModule,
    OutletModule,
    FeaturesConfigModule,
    NgSelectA11yModule,
    TooltipIconComponent
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchBoxComponent: {
          component: CustomSearchBoxComponent,
        },
      },
    }),
  ],
  exports: [CustomSearchBoxComponent, HighlightPipe],
})
export class CustomSearchBoxModule {}
